import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@material-ui/core';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';

const styles = (theme) => ({
  xs: {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
  },
  sm: {
    width: theme.spacing(3.75),
    height: theme.spacing(3.75),
  },
  lg: {
    width: theme.spacing(6.25),
    height: theme.spacing(6.25),
  },
  xl: {
    width: theme.spacing(7.5),
    height: theme.spacing(7.5),
  },
});

const PlannerAvatar = ({
  className,
  classes,
  planner,
  size,
}) => {
  let plannerName = null;
  let plannerAvatarSrc = null;

  /*
  * If you don't have a planner resource -> You get the avatar with the person icon inside
  * If you have a planner resource but no email -> You get the facet logo
  * If you have a planner resource and email but no image uploaded to S3 -> You get the avatar with your initial inside
  * If you have a planner resource, email, and image in S3 -> you get your S3 image
  * If an exception is thrown -> You get the facet logo
  * */
  if (planner) {
    plannerName = planner.attr('firstName');
    plannerAvatarSrc = planner.attr('profileURL');
  }

  return (
    <Avatar
      alt={`${plannerName} avatar`}
      src={plannerAvatarSrc}
      planner={planner}
      className={classNames(className, {
        [classes.xs]: size === 'xs',
        [classes.sm]: size === 'sm',
        [classes.lg]: size === 'lg',
        [classes.xl]: size === 'xl',
      })}
    />
  );
};

PlannerAvatar.defaultProps = {
  className: '',
  size: 'md',
};

PlannerAvatar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  planner: PropTypes.object.isRequired,
  size: PropTypes.oneOf([
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
  ]),
};

export default withStyles(styles)(PlannerAvatar);
